module.exports = __webpack_public_path__ + "img/Qoo10.d14db62c.svg";